import React, { useMemo } from 'react';

import ActionButton from 'components/action-button';
import { t } from 'state/intl/translations';

import { ModifierInformation } from './utils';

interface IMissingModifierSelectionCtaProps {
  modifierInformation: ModifierInformation;
}

export const MissingModifierSelectionCta = ({
  modifierInformation,
}: IMissingModifierSelectionCtaProps) => {
  const buttonLabel = useMemo(() => {
    const { modifier, modifierRemainingSelections, modifierQuantity } = modifierInformation;

    const modifierMaxAmount = modifierQuantity?.max ?? 0;
    const modifierMinAmount = modifierQuantity?.min ?? 0;
    const noSelectionsYet = modifierRemainingSelections === modifierMinAmount;
    if (noSelectionsYet) {
      const itemNameKey = modifierMaxAmount > 1 ? 'options' : 'option';
      const itemName = t(itemNameKey);
      return t('selectUpTo', { amount: modifierMaxAmount, itemName });
    }

    const isModifierMultipleChoice = modifierMaxAmount > 1;
    if (isModifierMultipleChoice) {
      return t('selectRemaining', { amount: modifierRemainingSelections });
    }

    // TODO: evaluate which menu object trigger this case
    const modifierName = modifier.name?.locale ?? '';
    return t('selectSingleChoice', { amount: modifierRemainingSelections, itemName: modifierName });
  }, [modifierInformation]);

  return (
    <ActionButton testID="product-home-action-button" disabled flex={1}>
      {buttonLabel}
    </ActionButton>
  );
};
